import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f3a85fa2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "index" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "test", -1 /* HOISTED */))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Hi, there!", -1 /* HOISTED */))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "set title by slot", -1 /* HOISTED */))
const _hoisted_5 = { style: {"flex":"auto"} }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "touch-demo" }, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_el_radio = _resolveComponent("el-radio")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_el_button, { onClick: $setup.do_test }, {
      default: _withCtx(() => [
        _createTextVNode("测试")
      ]),
      _: 1 /* STABLE */
    }),
    _createVNode(_component_el_button, { onClick: $setup.test_laravel }, {
      default: _withCtx(() => [
        _createTextVNode("测试laravel")
      ]),
      _: 1 /* STABLE */
    }),
    _createVNode(_component_el_drawer, {
      modelValue: $setup.drawer,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.drawer) = $event)),
      title: "I am the title",
      direction: $setup.direction,
      "before-close": $setup.handleClose
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue", "direction"]),
    _createVNode(_component_el_drawer, {
      modelValue: $setup.drawer2,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.drawer2) = $event)),
      direction: $setup.direction
    }, {
      header: _withCtx(() => [
        _hoisted_4
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_el_radio, {
            modelValue: $setup.radio1,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.radio1) = $event)),
            label: "Option 1",
            size: "large"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Option 1")
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["modelValue"]),
          _createVNode(_component_el_radio, {
            modelValue: $setup.radio1,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.radio1) = $event)),
            label: "Option 2",
            size: "large"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Option 2")
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["modelValue"])
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_button, { onClick: $setup.cancelClick }, {
            default: _withCtx(() => [
              _createTextVNode("cancel")
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: $setup.confirmClick
          }, {
            default: _withCtx(() => [
              _createTextVNode("confirm")
            ]),
            _: 1 /* STABLE */
          })
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue", "direction"]),
    _hoisted_6
  ]))
}